/* global axios */
import ApiClient from './ApiClient';

class EmailSendingDomains extends ApiClient {
  constructor() {
    super('email_sending_domains', { accountScoped: true });
  }

  share(id, recipientEmail) {
    return axios.post(`${this.url}/${id}/share`, {
      email_sending_domain: { recipient_email: recipientEmail },
    });
  }

  recheck(id) {
    return axios.post(`${this.url}/${id}/recheck`);
  }
}

export default new EmailSendingDomains();
